import React from "react";
import { useStaticQuery, graphql } from "gatsby";
const EmptyPicture = () => {
  const data = useStaticQuery(graphql`
    query {
      file(name: { eq: "emptyMedia" }) {
        id
        publicURL
      }
    }
  `);
  const srcImg = data.file.publicURL;
  return (
    <img
      src={srcImg}
      style={{ borderRadius: "5px" }}
      className="object-cover  w-full"
    />
  );
};

export default EmptyPicture;
